import {
  useAlertsManagementListFilter,
  useSetAlertsManagementListFilter,
} from '@gripp/shared-logic';
import { SlideAction, useSlideLayout, ViewMode } from '@gripp/shared-ui';
import { useRef } from 'react';
import { useNavigate } from 'react-router';
import { HeaderResetButton } from '../../shared/components/headerResetButton/headerResetButton';
import { AlertsManagementBase } from './alertsManagement';
import {
  AlertsManagementFilterScreen,
  AlertsManagementFilterScreenHandle,
} from './alertsManagementFilterScreen';

export const AlertsManagementFilterPage = () => {
  const filterRef = useRef<AlertsManagementFilterScreenHandle>(null);
  const onBackButtonPressRef = useRef<(() => void) | undefined>(undefined);

  const { data: filter } = useAlertsManagementListFilter();
  const { mutateAsync: setFilter } = useSetAlertsManagementListFilter();

  const rightColumn = {
    title: 'alertsManagement.menu.title',
    mainComponent: (
      <>
        <AlertsManagementFilterScreen
          ref={filterRef}
          filter={filter}
          setFilter={setFilter}
        />
        <BackHandlerRegistrar onBackButtonPressRef={onBackButtonPressRef} />
      </>
    ),
    headerComponent: (
      <HeaderResetButton onReset={() => filterRef.current?.onReset()} />
    ),
    showBackButton: true,
    onBackButtonPress: () => onBackButtonPressRef.current?.(),
  };

  return (
    <AlertsManagementBase rightColumn={rightColumn} viewMode={ViewMode.DUAL} />
  );
};

const BackHandlerRegistrar = ({
  onBackButtonPressRef,
}: {
  onBackButtonPressRef: React.MutableRefObject<(() => void) | undefined>;
}) => {
  const navigate = useNavigate();
  const { onSlideChange } = useSlideLayout();

  onBackButtonPressRef.current = async () => {
    await onSlideChange(SlideAction.SINGLE);
    navigate('/alerts-management');
  };

  return null;
};
